// PR_RUN_056 — Charstan deployment / fork-session version stamp (frontend mirror).
//
// MUST stay in lockstep with `backend/app_version.py::APP_VERSION`.
// The PR_RUN_056 pytest asserts both constants match — if you bump one,
// bump the other in the same commit.
//
// Format: CHARSTAN_Ver_<major>.<minor>_<DDMONYY>  (see app_version.py for rationale)
// Bump trigger: production redeploy OR forked agent context-window session.

export const APP_VERSION = "CHARSTAN_Ver_1.0_27MAY26";
export const APP_VERSION_RELEASED_AT = "2026-05-27";

export default APP_VERSION;
